import { PropTypes } from 'base/react-libs';
import { getContactEmailAddress } from 'apps/journeys/utils/helpers/utils';
import DialerDrawerButton from 'components/drawer/components/dialer-drawer-button';
import EmailerDrawerButton from 'components/drawer/components/emailer-drawer-button';

const TaskRowOutreachButtons = ({ task = {}, onDrawerOpen, onDrawerClose }) => {
  if (!task) return null;
  const { contact, action_type } = task || {};

  return (
    <>
      {task && contact && (
        <>
          {action_type === 'CALL' && (
            <DialerDrawerButton
              contact={contact}
              phones={contact.phones || []}
              onDrawerOpen={onDrawerOpen}
              onDrawerClose={onDrawerClose}
            />
          )}
          {action_type === 'EMAIL' && (
            <EmailerDrawerButton
              task={task}
              contact={contact}
              emailAddress={getContactEmailAddress(contact)}
              onDrawerOpen={onDrawerOpen}
              onDrawerClose={onDrawerClose}
            />
          )}
        </>
      )}
    </>
  );
};

TaskRowOutreachButtons.propTypes = {
  task: PropTypes.object.isRequired,
  onDrawerOpen: PropTypes.func,
  onDrawerClose: PropTypes.func,
};

export default TaskRowOutreachButtons;
